import { Injectable } from '@angular/core';
import {
	CertMetricsMutationDeleteClientLocalizationListArgs,
	ClientLocalization,
} from '@ats/api/cm';
import { CmInterceptHeaders } from '@ats/cm/core';
import { gql, Mutation } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { ENTRY_EXISTS_GUID } from '../models/ignored-error-guids';

@Injectable({
	providedIn: 'root',
})
export class ClientLocalizationDeleteGql extends Mutation<
	{ updateClientLocalizationList: ClientLocalization[] },
	{ request: CertMetricsMutationDeleteClientLocalizationListArgs['request'] }
> {
	document = gql`
		mutation deleteClientLocalizationList($request: DeleteLocalizationListRequest!) {
			deleteClientLocalizationList(request: $request) {
				name
				locType
				value
				englishValueResolved
				cultureInfoName
			}
		}
	`;

	delete$(
		request: CertMetricsMutationDeleteClientLocalizationListArgs['request']
	): Observable<boolean> {
		return this.mutate(
			{ request },
			{ context: { headers: CmInterceptHeaders.SuppressErrorById(ENTRY_EXISTS_GUID) } }
		).pipe(map(({ data }) => (data?.updateClientLocalizationList || []).length > 0));
	}
}
